/** @format */
import {
    Icon,
    IconSize,
    IconVariant,
} from '@mpb-com/feather/components/atoms/icon';
import React from 'react';

import Checkmark from '@toucan/client/global/icons/checkmark.svg';

import { Flag } from '@toucan/client/shared/components/market-flag';

import { handleMarketChange } from './helpers';
import { useTranslatedMarketName } from './hooks/use-translated-market-name';
import {
    CheckmarkIconWrapper,
    MarketSelectorLinkWrapper,
} from './modal-link.styles';
import { MarketSelectorLinkProps } from './types';

export const MarketSelectorModalLink = ({
    market,
    selected = false,
}: MarketSelectorLinkProps) => {
    function onLinkClick() {
        if (selected) {
            return;
        }

        handleMarketChange(market);
    }

    const marketName = useTranslatedMarketName(market.code);

    return (
        <MarketSelectorLinkWrapper selected={selected} onClick={onLinkClick}>
            <Flag data-testid="market-selector-link" marketCode={market.code} />
            <div>{marketName}</div>
            {selected && (
                <CheckmarkIconWrapper data-testid="market-selector-link__checkmark">
                    <Icon variant={IconVariant.DECORATIVE} size={IconSize.S}>
                        <Checkmark />
                    </Icon>
                </CheckmarkIconWrapper>
            )}
        </MarketSelectorLinkWrapper>
    );
};
